const formHelper = ( formSelect ) => {

    const forms = document.querySelectorAll( '.wpcf7-form' );

    async function sendData( formData ) {

        let response = await fetch( GLOBAL_DATA.ajaxUrl, {
            method: 'POST',
            body: formData
        });

        if (!response.ok)
            throw new Error( response.status );

        return response.json();

    }

    forms.forEach( ( form ) => {

        const inputsLabel = form.querySelectorAll('p>label');

        inputsLabel.forEach( ( label ) => {

            const field = label.querySelector('.wpcf7-form-control');



            if ( field.value !== '' )
                label.querySelector('span:first-child').style.opacity = 1;

            field.addEventListener( 'change', function () {
                if ( field.type === 'file' ) {
                    label.querySelector('b').innerHTML = this.files[0].name;
                }
            } );

            field.addEventListener( 'focus', function () {
                label.querySelector('span:first-child').style.opacity = 1;
            } );

            field.addEventListener( 'blur', function () {

                if ( field.value === '' ) {
                    label.querySelector('span:first-child').style.opacity = 0;
                    return
                }

                label.querySelector('span:first-child').style.opacity = 1;
            } );
        } );

        form.addEventListener( 'wpcf7mailsent', function( e ) {

            const submitBtn = e.target.querySelector( 'input[type=submit]' );
            submitBtn.setAttribute('disabled', 'disabled');

            let formData = e.detail.formData;
            formData.set( 'action', 'sending_data' );
            formData.set( 'current-url', GLOBAL_DATA.currentUrl );

            sendData( formData )
                .then( response => {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'event': response.analytics_event,
                    });

                    this.closest('.form').querySelector('#thank_you_pop_up').style.display = 'block';
                } )
                .catch( err => {
                    console.log( err );
                } )
                .finally( () => {
                    const inputsLabel = this.querySelectorAll('p>label');
                    for ( const labl of inputsLabel ) {
                        labl.querySelector('span:first-child').style.opacity = 0;
                    }
                    submitBtn.removeAttribute('disabled' );
                } );

        }, false );

    } );
}

export default formHelper;